const VistaFacturacionCentro = () =>
  import('Modules/tesoreria/facturacion/views/FacturacionCentro')
const VistaFacturacionAsociacion = () =>
  import('Modules/tesoreria/facturacion/views/FacturacionAsociacion')
const VistaRecibos = () =>
  import('Modules/tesoreria/recibos/views/Recibo')
const VistaProyectosPago = () =>
  import('Modules/tesoreria/proyectosPago/views/ProyectoPago')
const VistaOrdenesPago = () =>
  import('Modules/tesoreria/ordenesPago/views/OrdenPago')
const VistaInterfaces = () =>
  import('Modules/tesoreria/interfaces/views/Interfaces')
const VistaRetenciones = () =>
  import('Modules/tesoreria/retenciones/views/Retencion')
const rutas = [
  {
    name: 'facturacion-centro',
    component: VistaFacturacionCentro,
    path: '/tesoreria/facturacion-centro',
    meta: {
      requiresAuth: true,
      title: 'Facturación Centro',
      breadcrumb: null,
      menu: 'tesoreria'
    }
  },
  {
    name: 'facturacion-asociacion',
    component: VistaFacturacionAsociacion,
    path: '/tesoreria/facturacion-asociacion',
    meta: {
      requiresAuth: true,
      title: 'Facturación Asociacion',
      breadcrumb: null,
      menu: 'tesoreria'
    }
  },
  {
    name: 'recibos',
    component: VistaRecibos,
    path: '/tesoreria/recibos',
    meta: {
      requiresAuth: true,
      title: 'Recibos',
      breadcrumb: null,
      menu: 'tesoreria'
    }
  },
  {
    name: 'proyectos-pago',
    component: VistaProyectosPago,
    path: '/tesoreria/proyectos-pago',
    meta: {
      requiresAuth: true,
      title: 'Proyectos de pagos',
      breadcrumb: null,
      menu: 'tesoreria'
    }
  },
  {
    name: 'ordenes-pago',
    component: VistaOrdenesPago,
    path: '/tesoreria/ordenes-pago',
    meta: {
      requiresAuth: true,
      title: 'Ordenes de pagos',
      breadcrumb: null,
      menu: 'tesoreria'
    }
  },
  {
    name: 'interfaces',
    component: VistaInterfaces,
    path: '/tesoreria/interfaces',
    meta: {
      requiresAuth: true,
      title: 'Interfaces',
      breadcrumb: null,
      menu: 'tesoreria'
    }
  },
  {
    name: 'retenciones',
    component: VistaRetenciones,
    path: '/tesoreria/retenciones',
    meta: {
      requiresAuth: true,
      title: 'Ietenciones',
      breadcrumb: null,
      menu: 'tesoreria'
    }
  }
]

export default rutas
